import { oauthApi } from '../../apis';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMe } from '../../organisation/useMe';

const API_CLIENTS_QUERY_KEY = ['apiClients'];

export const useQueryApiClients = () => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: [...API_CLIENTS_QUERY_KEY, currentOrganisation?.id],
    queryFn: () => oauthApi.getClientDetails().then((response) => response.clients),
  });
};

export const useCreateApiClient = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => oauthApi.createClientDetails(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: API_CLIENTS_QUERY_KEY }),
  });
};

export const useDeleteApiClient = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (clientId: string) => oauthApi.deleteClientDetails({ clientId }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: API_CLIENTS_QUERY_KEY }),
  });
};
